
<template>
  <div class="approval-detail" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="explain">
      <div class="explain-header">
        <b class="font-S20">{{ flowName }}</b>
        <span class="state-approval state-now" v-if="costDetail.approvalState == 'N' || costDetail.approvalState == 'A'">审批中</span>
        <span class="state-approval state-pass" v-if="costDetail.approvalState == 'Y'">已通过</span>
        <span class="state-approval state-reject" v-if="costDetail.approvalState == 'R'">已驳回</span>
        <span class="state-approval state-undo" v-if="costDetail.approvalState == 'C'">已撤销</span>
        <span :class="costDetail.approvalState == 'Y' ? 'now-state state-back fr' : 'now-state state-back fr ml30'" @click="$router.go(-1)">返回</span>
        <span class="now-state state-back fr mr15 ml30" v-if="costDetail.approvalState == 'Y'" @click="toPrinting()">打印</span>
        <span class="now-state state-now-unpass fr mr15" v-if="approveStaffGuid == staffGuid && (costDetail.approvalState == 'N' || costDetail.approvalState == 'A')" @click="toReject()">驳回</span>
        <span class="now-state state-now-pass fr mr15" v-if="approveStaffGuid == staffGuid && (costDetail.approvalState == 'N' || costDetail.approvalState == 'A')" @click="toPass()">通过</span>
        <!-- <span class="now-state state-now-pass fr mr15" v-if="(costDetail.approvalState == 'R' || costDetail.approvalState == 'C') && costDetail.staffGuid == staffGuid" @click="reSubmit()">重新提交</span> -->
        <span class="now-state state-now-revoke fr mr15" v-if="costDetail.approvalState == 'N' && submitStaffGuid == staffGuid" @click="toRevoke()">撤销</span>
        <span class="now-state state-now-revoke fr mr15" v-if="costDetail.staffGuid == staffGuid && (costDetail.approvalState == 'N' || costDetail.approvalState == 'A') && !urgeNotifySh" @click="urgeNotify()">提醒</span>
        <span class="now-state state-now-revoke fr mr15" v-if="approveStaffGuid == staffGuid && (costDetail.approvalState == 'N' || costDetail.approvalState == 'A') && urgeNotifySh" @click="noticeOrsignMessage()">提醒</span> 
        <span class="now-state state-now-revoke fr mr15" v-if="allowAddSign == 1 && approveStaffGuid == staffGuid && (costDetail.approvalState == 'N' || costDetail.approvalState == 'A')" @click="getVisible7">加签</span>
      </div>
      <div class="cost-title-list">
        <span class="cost-title-list-line"></span>
        <span class="cost-title-list-txt">申请信息</span>
      </div>
      <div class="explain-contain">
        <div class="explain-item">
          <span class="explain-title">申请人：</span> <span class="explain-content">{{ submitStaffName }}</span>
        </div>
        <div class="explain-item">
          <span class="explain-title">提交时间：</span>
          <span class="explain-content">{{ costDetail.approvalSubmitTime | getTime }}</span>
        </div>
        <div class="explain-item">
          <span class="explain-title">所在部门：</span>
          <span class="explain-content">{{ costDetail.organisationName }}</span>
        </div>
    
        <div class="explain-item">
          <span class="explain-title">客户名称：</span>
          <span class="explain-content">{{ costDetail.customerName }}</span>
        </div>
        <div class="explain-item">
          <span class="explain-title">客户联系方式：</span>
          <span class="explain-content">{{ costDetail.contacts }} {{ costDetail.contactTel }} </span>
        </div> 
       <div class="explain-item">
          <span class="explain-title">客户地址：</span>
          <span class="explain-content">{{ costDetail.address }}</span>
        </div>
        <div class="explain-item">
          <span class="explain-title">原客户等级：</span>
          <span class="explain-content">{{ transform(getFieldConfig("level", "selectItemList"), costDetail.originalLevel )}}</span>
        </div>
        <div class="explain-item">
          <span class="explain-title">新客户等级：</span>
          <span class="explain-content">{{ transform(getFieldConfig("level", "selectItemList"), costDetail.newLevel )}}</span>
        </div>
        <div class="explain-item">
          <span class="explain-title">说明原因：</span>
          <span class="explain-content">{{ costDetail.changeCause }}</span>
        </div>
        <div class="explain-item" v-if="allowAddSign == 1 && approveStaffGuid == staffGuid && (costDetail.approvalState == 'N' || costDetail.approvalState == 'A')">
          <span class="explain-title">加签人：{{addSignStaffName}}</span>
          <!-- <div class="cost-approve-list-content">
            <el-input type="text" v-model="addSignStaffName" @focus="getVisible7" autocomplete="off"></el-input>
          </div> -->
        </div>
      </div>
      <iframe v-if="iframeSh" :src="srcs" class="iframe-sty"></iframe>
    </div>
    <div class="h20"></div>
    <!-- 选择人员 -->
    <el-dialog title="选择人员" :visible.sync="visible7" width="60%" center>
      <div>
        <div class="select-box">
          <div class="box-left fl">
            <el-input v-model="filterText7" class="mt15" placeholder="请输入部门/人员名称"></el-input>
            <el-tree class="filter-tree mt10" :data="areaDataR" :props="defaultProps" :show-checkbox="true" node-key="guid" :filter-node-method="filterNodeDep7" @node-click="handleNodeClick7" ref="treeDep7"
               @check-change="checkChange7">
              <div class="custom-tree-node" slot-scope="{ node,data }">
                <img :src="data.icon" alt="">
                <!-- <img src="../../assets/images/icon_per.png" alt=""> -->
                <span>{{ data.label }} <span class="remark-class" v-if="data.remark">（{{ data.remark }}）</span></span>
              </div>
            </el-tree>
          </div>
          <div class="box-right fr">
            <p class="fontC-bbb fl">已选{{ departmentList7.length }}人</p>
            <el-button size="medium" type="danger" @click="delDepartment7()" class="fr" style="margin-top: 5px">批量删除
            </el-button>
            <el-table :data="departmentList7" border height="280px" style="width: 100%" @selection-change="handleSelectionChange7">
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column header-align="center" align="center" show-overflow-tooltip prop="label" label="名称">
                <template slot-scope="scope">
                  {{scope.row.label}}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer t-right">
        <el-button plain size="medium" @click="visible7 = false">取消</el-button>
        <el-button size="medium" type="info" @click="submitDepartment7()" v-loading.fullscreen.lock="fullscreenLoading">确定</el-button>
      </div>
    </el-dialog>
    <!-- 驳回 -->
    <el-dialog title="驳回流程" :visible.sync="rejectDialogVisible" width="30%" top="15%">
      <el-input type="textarea" :rows="5" placeholder="输入驳回理由（必填）" v-model="approveSuggest"> </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toRejectSubmit()">驳回</el-button>
      </span>
    </el-dialog>
    <!-- 通过  -->
    <el-dialog title="通过流程" :visible.sync="passDialogVisible" width="30%" top="15%">
      <el-input type="textarea" :rows="5" placeholder="输入通过备注（非必填）" v-model="approveSuggest"> </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toPassSubmit()">通过</el-button>
      </span>
    </el-dialog> 
    <printDialog :showPrintDialog.sync='showPrint' :printData="costDetail" :printType="7" :approvalList="approvalList" @closePrint="closePrint"></printDialog>
  </div>
</template>
<script>
import { bpmnroute } from '../../api/apiRoute';
import flowList from '@/components/flowList.vue';
import printDialog from '@/components/printDialog.vue';
export default {
  components: {
    flowList,
    printDialog
  },
  data() {
    return {
      dialogVisibleFile:false,
      rejectDialogVisible:false,
      passDialogVisible:false,
      btnLoading:false,
      costDetail: {},
      approveSuggest: '',
      flowName: '变更客户等级',
      carbonName: '',
      approvalList: [],
      approveStaffGuid: '',
      staffGuid: '',
      flowType: '00008',
      fullscreenLoading: false,
      showPrint:false, //打印
      srcs: '',
      processInstanceId: '',
      iframeSh: false,
      staffGuidSh: false,
      urgeNotifySh: false,
      departmentList7: [],
      filterText7: '',
      visible7: false,
      delList7: [],
      areaDataR:'',
      defaultProps: {
        id: 'id',
        label: 'label',
        children: 'children', 
      },
      addSignStaffGuid:'',
      addSignStaffName:'',
      allowAddSign:'',
      submitStaffName:'',//提交人
      submitStaffGuid:''//提交人
    };
  },
  watch: {
    filterText7(val) {
      this.$refs.treeDep7.filter(val);
    }
  },
  created() {
    let userinfo = JSON.parse(localStorage.userInfo);
    this.staffGuid = userinfo.staffGuid;
    this.getOrganisationR();
    this.approveStaffGuid = this.$route.query.approveStaffGuid;
    this.submitStaffName = this.$route.query.submitStaffName;
    this.submitStaffGuid = this.$route.query.submitStaffGuid;
    this.getData();
    this.getApprovalList();
    if(this.$route.query.camundaInstanceId&&this.$route.query.camundaDeploymentId){
      // this.getToken();  
      this.setSrcs();
      this.getActivityTask(); 
    }
  },
  methods: {
    //获取配置下拉选项
    transform(list, val) {
      var name = '暂无等级';
      if (list && list.length > 0) {
        list.forEach((item) => {
          if (val == item.value ) {
            name = item.text;
          }
        });
      }
      return name; 
    },
    //获取配置对应字段
    getFieldConfig(params, key) {
      var fieldList = JSON.parse(localStorage.getItem("WNQYDJD_CONFIG")).fieldList;
      var newConfig = {};
      fieldList.forEach((item) => {
        if (item.fieldName == params) {
          newConfig = item;
        }
      });
      return newConfig && newConfig[key];
    },
    getData() {
      let self = this;
      this.fullscreenLoading = true;
      let query ={
        tenantGuid:localStorage.guid,
        guid:self.$route.query.bizGuid
      }
      self.api
        .postJson(`/${serverConfig.msCustomerService}/wnq/customer/data/get-detail?guid=${self.$route.query.objectGuid}&approvalGuid=${self.$route.query.guid}`)
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.costDetail = res.data.data?res.data.data:{};
            self.getPageChangeData();
            if(!res.data.data){
              self.$message.error('未获取到数据');
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //修改前的数据
    getPageChangeData(){
      this.api.get(
        `/${serverConfig.msConfigureService}/data-alter/audit/todo-detail?guid=${this.$route.query.bizGuid}`
      ).then(res => {
        if (res.data.code == "00000") {
          if (res.data.data) {
            let data = res.data.data;
            let originalLevel = data.valueOriginal ? JSON.parse(data.valueOriginal).level : '';
            let newLevel = data.valueNew ? JSON.parse(data.valueNew).level : '';
            this.$set(this.costDetail,'originalLevel',originalLevel);
            this.$set(this.costDetail,'newLevel',newLevel);
            this.$set(this.costDetail,'changeCause',data.changeCause);
            console.log('first',this.costDetail)
          }
        }else{
          this.$message.error(res.data.msg);
        }
      });
    },
    //获取流程列表
    getApprovalList() {
      let self = this;
      self.api
        .postCan(
          `/${serverConfig.msSalesPerformService}/work-flow/data/get-flow-running-node?flowType=00008&guid=` + self.$route.query.guid,
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let ccGuids = '';
            let data = res.data.data;
            if(data){
              data.forEach((i)=>{
                if(i.flowNodeType== 2 && i.ccGuids != '[]'){
                  ccGuids = i.ccGuids;
                }
              })
              self.approvalList = data; 
              if(self.approvalList){
                self.approvalList.sort((n1, n2) => {
                  return n1.orderNum - n2.orderNum;
                });
                self.approvalList.forEach((j)=>{  
                  if(ccGuids){
                    j.ccGuids = ccGuids;
                  } 
                })
                if(res.data.data && res.data.data[0].ccGuids != '[]'){ 
                  self.carbonName = res.data.data[0].ccGuids ? JSON.parse(res.data.data[0].ccGuids)[0].name : ''; 
                }
              }
            } 
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //打印关
    closePrint(){
      this.showPrint = false;
    },
    //打印开
    toPrinting() {
      this.showPrint = true;
    },
    //撤销
    toRevoke() {
      let self = this;
      self
        .$confirm('确定撤销吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          let query = {
            guid: self.$route.query.guid,
            flowType: self.flowType,
            approveStaffGuid:self.staffGuid
          };
          self.fullscreenLoading = true;
          self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/canal-flow`, query).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.fullscreenLoading = false;
              self.$message.success('撤销成功！');
              sessionStorage.refresh = 1;
              self.$router.go(-1);
            } else {
              self.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {
          self.$message({
            type: 'info',
            message: '已取消操作！',
          });
        });
    },
    toPass(){
      let self = this;
      self.approveSuggest = "";
      self.passDialogVisible = true;
    },
    toReject() {
      let self = this;
      self.approveSuggest = "";
      self.rejectDialogVisible = true;
    },
    //通过
    toPassSubmit() {
      let self = this;
      let query = {
        guid: self.$route.query.guid,
        flowType: self.flowType,
        approveSuggest: self.approveSuggest,
        approveStaffGuid: self.staffGuid,
        addSignStaffGuid: self.addSignStaffGuid
      };
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/allow-flow`, query).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) { 
          self.$message.success('审批通过！');
          sessionStorage.refresh = 1;
          self.$router.go(-1);
        } else {
          if(res.data.msg == '任务ID不能为空。'){
            self.$message.error('当前流程已审批!');
            location.reload();
          }else{
            self.$message.error(res.data.msg);
          }
        }
      });
    },
    //驳回
    toRejectSubmit() {
      let self = this;
      if (self.approveSuggest == '') {
        self.$message.error('请填写驳回理由！');
        return;
      }
      let query = {
        guid: self.$route.query.guid,
        flowType: self.flowType,
        approveSuggest: self.approveSuggest,
        approveStaffGuid: self.staffGuid
      };
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/backup-flow`, query).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) { 
          self.$message.success('驳回成功！');
          sessionStorage.refresh = 1;
          self.rejectDialogVisible = false;
          self.$router.go(-1);
        } else {
          if(res.data.msg == '任务ID不能为空。'){
            self.$message.error('当前流程已驳回!');
            location.reload();
          }else{
            self.$message.error(res.data.msg);
          }
        }
      });
    },


    
    getVisible7(){
      this.filterText7 = '';
      this.visible7 = true;
    },
    //部门弹框选择
    handleNodeClick7(data) {
      let self = this;
      console.log(data); 
      console.log(self.departmentList7);
    },
    handleSelectionChange7(val) {
      let self = this;
      self.delList7 = val;
      console.log(val);
    },
    filterNodeDep7(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    delDepartment7() {
      let self = this;
      if (self.delList7 == null || self.delList7.length == 0) {
        self.$message.error('请勾选人员！');
        return;
      }
      self.delList7.forEach(function(j) {
        self.departmentList7.forEach(function(i, index) {
          if (i.id == j.id) {
            self.departmentList7.splice(index, 1);
          }
        });
      });
      this.$refs.treeDep7.setCheckedNodes(this.departmentList6);
    },
    checkChange7(val) {
      // console.log(this.$refs.treeDep2.getCheckedNodes());
      this.departmentList7 = [];
      let checkNodes = this.$refs.treeDep7.getCheckedNodes();
      if(checkNodes && checkNodes.length > 1){
        this.$message.error("只能选择一个人！");
        this.departmentList7 = [];
        return;
      }
      if(checkNodes.length > 0){
        checkNodes.forEach((i)=>{
          if(i.nodeType == 2){   //注释掉  可同时选择人员与部门
            this.departmentList7.push(i);
          }
        })
      }
      // this.departmentList = this.$refs.treeDep.getCheckedNodes(); 
      console.log('1111111',this.departmentList7);
    }, 
    //获取组织人员 不刷新
    getOrganisationR() {
      let self = this;
      let orgStaffGuid = [];
      self.api.postJson(
        `/camunda-server/usergroup/get-tenant-organisation-staff-tree?&tenantGuid=`+localStorage.guid+'&productSign=FBT',orgStaffGuid
      )
      .then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.areaDataR = res.data.data;
          self.treeDataR(res.data.data);
        } else {
          self.$message.error(res.data.msg);
          self.areaDataR = [];
        }
      });
    }, 
    treeDataR(areaDataR) {
      var self = this;
      // const treeData = [];
      // const getPerson = () => {};
      const fn = (tree) => { 
        if(tree){
          tree.forEach(async (k) => {  
            let icon = '';
            if(k.nodeType == 2){
              icon = require("../../assets/images/icon_per.png");
            }else{
              icon = require("../../assets/images/ico_ora.png");
            } 
            k.label = k.name;
            k.id = k.guid;
            k.icon = icon;
            // 根据id获取人员数据,(注意转为树类型)
            if (k) {
              // const person = await self.getStaff(k.guid);  
              if(k.children){
                k.children.forEach((d)=>{  
                  let icon1 = '';
                  let item = '';
                  if(d.nodeType == 2){
                    icon1 = require("../../assets/images/icon_per.png"); 
                    d.id = d.guid;
                    d.label = d.name+d.mobileNo;
                    d.nodeType = d.nodeType; 
                    d.icon = icon1 
                  }else{
                    icon1 = require("../../assets/images/ico_ora.png"); 
                    d.id = d.guid;
                    d.label = d.name+d.mobileNo;
                    d.nodeType = d.nodeType;
                    d.disabled = true;
                    d.icon = icon1;
                  }   
                })
              }
              const person = [];
              const isValid = (val) => {
                return val && val !== null && JSON.stringify(val) !== '[]';
              };
              // 将人员数据拼接到chilren里面
              if (k.children) {
                fn(k.children);
                isValid(person) && (k.children = [...k.children, ...person]);
                // 有子元素，需要调用自身
              } else {
                isValid(person) && (k.children = person);
              }
            }
          });
        }
      };
      fn(areaDataR);
      console.log(areaDataR);
    },
    //指定抄送人
    submitDepartment7(){
      let self = this;
      let userGuids = [];
      let userNames = [];
      let departments = [];
      let departmentNames = [];
      if(self.departmentList7){
        self.departmentList7.forEach(i => {
          if(i.nodeType == 2){ 
            userGuids.push(i.id);
            userNames.push(i.name);
          }
        });
      } 
      self.visible7 = false; 
      if(userNames && userNames.length == 1){
        self.addSignStaffGuid = userGuids[0];
        self.addSignStaffName = userNames[0];
      }
    },
    getActivityTask() {
      let self = this;
      let processInstanceId = "";
      if (self.$route.query.camundaInstanceId) {
        processInstanceId = self.$route.query.camundaInstanceId;
      } else {
        processInstanceId = self.$route.query.processInstanceId;
      }
      let item = {
        processInstanceId: processInstanceId,
      };
      self.api.get(
        "/camunda-server/process-definition/get-activity-task",
        item
      ).then((res) => {
        if (res.data.code == "00000") {
          let data = res.data.data; 
          if(data && data[0].allowAddSign == 1){
            self.allowAddSign = 1;
          }else{
            self.allowAddSign = '';
          }
          if(this.$route.query.approveStaffGuid){
            if (data && data[0].taskType == "或签") {
              self.urgeNotifySh = true;
            } else {
              self.urgeNotifySh = false;
            }
          }
        }
      });
    },
    setSrcs() { 
      this.iframeSh = true;
      this.srcs = bpmnroute + '/iframeBpmn?processInstanceId='+this.$route.query.camundaInstanceId + '&camundaDeploymentId='+ this.$route.query.camundaDeploymentId+'&token='+ localStorage.token;
    },
    getToken(){
      let self = this; 
      self.api.postJson(`/csbr-zuul/user/refreshToken?token=${localStorage.token}`).then(res => {
        if (res.data.msg == "token延期成功!") {
          let token = res.data.data.refreshToken;
          if(self.$route.query.camundaInstanceId && self.$route.query.camundaDeploymentId){
            self.iframeSh = true;
            self.srcs = bpmnroute + '/iframeBpmn?processInstanceId='+this.$route.query.camundaInstanceId + '&camundaDeploymentId='+ self.$route.query.camundaDeploymentId+'&token='+token;
          }
          // self.srcs = 'http://117.78.34.191:8925/bpmn?token='+ token + '&flowTemplateGuid='+ self.$route.query.flowTemplateGuid + '&deploymentId='+ self.$route.query.deploymentId + '&tenantGuid='+ self.$route.query.tenantGuid + '&flowName='+ self.$route.query.flowName;
          // self.srcs = 'http://192.168.2.175:9001/bpmn?token='+ token + '&flowTemplateGuid='+ self.$route.query.flowTemplateGuid + '&deploymentId='+ self.$route.query.deploymentId + '&tenantGuid='+ self.$route.query.tenantGuid + '&flowName='+ self.$route.query.flowName;
        }
      })
    },
    urgeNotify() {
      var self = this;
      let guid = self.$route.query.guid;
      self.api.post(
        `/${serverConfig.msSalesPerformService}/work-flow/data/urge-notify?approvalGuid=` +
          guid
      ).then(function (resp) {
        if (resp.data.code == '00000') { 
          self.$message.success('提醒成功！');
        } else {
          self.$message.error(resp.data.msg);
        }
      });
    },
    noticeOrsignMessage() {
      var self = this;
      let guid = self.$route.query.guid;
      self.api.post(
        `/${serverConfig.msSalesPerformService}/work-flow/data/notice-orsign-message?approvalGuid=` +
          guid
      ).then(function (resp) {
        if (resp.data.code == '00000') { 
          self.$message.success('提醒成功！');
        } else {
          self.$message.error(resp.data.msg);
        }
      });
    },
  },
};
</script> 
<style scoped>
 .iframe-sty{ 
  width:100%;
  height: 500px;
  border:none;
  /* background:grey; */
 }
.explain {
  background: #fff;
  border-radius: 4px;
  text-align: left;
  margin: 20px 14px;
  overflow: hidden;
  padding: 0 20px 30px 20px;
}
.explain-header {
  padding: 20px 0;
  overflow: hidden;
  /* border-bottom: 1px solid #ccc; */
}
.explain-header b {
  font-size: 20px;
  font-weight: 400;
  color: #323233;
}
.explain-contain {
  padding: 20px 20px 30px 60px;
}
.explain-title {
  /* width: 130px; */
  display: inline-block;
}
.cost-img {
  width: 300px;
}
.state-approval {
  font-size: 12px;
  display: inline-block;
  padding: 3px 10px 4px 10px;
  border-radius: 10px;
  margin-left: 20px;
}

.now-state {
  width: 112px;
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  cursor: pointer;
  text-align: center;
  box-sizing: border-box;
}
.state-now-pass {
  color: #fff;
  background: #4fa1a4;
}
.state-now-unpass {
  color: red;
  border: 1px solid red;
}
.state-now-revoke {
  color: #4fa1a4;
  border: 1px solid #4fa1a4;
}
.state-back {
  width: 112px;
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  color: #323233;
  text-align: center;
  cursor: pointer;
  border: 1px solid #c8c9cd;
}
.approval {
  margin: 10px 10px 60px 10px;
  background: #fff;
  border-radius: 4px;
  text-align: left;
  padding: 30px 60px 60px 60px;
}
.approval-list {
  display: flex;
}
.list-left {
  margin-right: 10px;
}
.left-box {
  width: 55px;
  height: 55px;
  color: #fff;
  line-height: 51px;
  background: #999;
  text-align: center;
  border-radius: 4px;
  margin: 0px 10px;
}
.left-line {
  width: 0.5px;
  height: 40px;
  background: #999;
  margin-left: 37px;
}
.approval-list:last-child .list-left .left-line {
  display: none;
}
.state-now {
  color: #e59940;
  background: rgba(255, 242, 224, 0.23);
}
.state-pass {
  color: #4fa1a4;
  background: rgba(79, 161, 164, 0.1);
  /* border: 1px solid #4fa1a4; */
}
.state-reject {
  color: rgb(255, 85, 85);
  background: rgba(255, 85, 85, 0.07);
  /* border: 1px solid rgb(255, 85, 85); */
}
.state-undo {
  color: rgb(197, 202, 213);
  background: #fff;
  border: 1px solid rgb(197, 202, 213);
}
.title-pass {
  background: #4fa1a4 !important;
}
.title-reject {
  background: red !important;
}
.explain-item {
  line-height: 40px;
  display: flex;
}
.explain-title {
  flex-shrink: 0;
}
.explain-content {
  display: inline-block;
  /* line-height: 30px; */
}

.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}

.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}

.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 10px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}

.tab-input {
  width: 100%;
  margin-bottom: 10px;
}

.custom-tree-node {
  display: flex;
  align-items: center;
}

.custom-tree-node img {
  width: 18px;
  margin-right: 10px;
}
.level-item{
  display: flex;
  align-items: center;
  margin-bottom: 30px;
}
</style>